import * as tslib_1 from "tslib";
import xamatron from "xamatron";
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import VueI18n from "vue-i18n";
import VueRouter from "vue-router";
import VModal from "vue-js-modal";
import Mixins from "vue-mixins";
import * as VueGoogleMaps from "vue2-google-maps";
import "components";
import i18n from "i18n";
import { routes } from "views";
import { routeDepth, getQueryStringArgs } from "utils";
import { loadStore } from "store";
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyCjQ4VxSXSSP6JSe-oE0sJH9VQFRZztk2k",
    }
});
// old key= "AIzaSyBvqhCSuUiU3iMvCCj5oves9y2MEIGX4CQ",
Vue.mixin(Mixins);
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(VModal, { dialog: true });
var AiRoot = /** @class */ (function (_super) {
    tslib_1.__extends(AiRoot, _super);
    function AiRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.routeTransition = "slide-left";
        _this.environment = process.env.NODE_ENV;
        return _this;
    }
    Object.defineProperty(AiRoot.prototype, "hasSubView", {
        get: function () {
            return !!this.$route.matched.find(function (r) { return r.meta && r.meta.hasChildren; });
        },
        enumerable: true,
        configurable: true
    });
    AiRoot.prototype.created = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var m;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        axios.defaults.baseURL = getQueryStringArgs().apiurl || "/api/";
                        axios.defaults.paramsSerializer = axiosParamsSerializer;
                        axios.defaults.headers["Cache-control"] = "no-cache";
                        //   await loadStore();
                        this.$watch("$route", function (to, from) {
                            _this.routeTransition = (routeDepth(to) < routeDepth(from)) ? "slide-right" : "slide-left";
                        });
                        xamatron.setBackButtonHandler(function () { return _this.back(); });
                        this.$router.push("/start");
                        m = (location.hash || "").match(/^#!(.*)/);
                        if (m)
                            this.$router.push(m[1]);
                        return [4 /*yield*/, loadStore()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AiRoot.prototype.viewTransitionAfterLeave = function () {
        this.$refs.viewContainer.scrollTo(0, 0);
    };
    AiRoot.prototype.getDeviceId = function () {
        var id = localStorage.getItem("deviceId");
        if (!id) {
            id = tslib_1.__spread(Array(32)).map(function (i) { return Math.floor(Math.random() * 16).toString(16); }).join("");
            localStorage.setItem("deviceId", id);
        }
        return id;
    };
    AiRoot.prototype.showDialog = function (options) {
        var _this = this;
        if (this.dialogResolve) {
            this.$modal.hide("dialog");
            this.dialogResolve(null);
        }
        return new Promise(function (resolve) {
            var buttons = (options.buttons || [{ title: _this.$t("common.ok"), result: true }])
                .map(function (btn) { return (tslib_1.__assign({}, btn, { handler: function () {
                    _this.dialogResolve = null;
                    _this.$modal.hide("dialog");
                    resolve(btn.result || null);
                } })); });
            _this.dialogResolve = resolve;
            _this.$modal.show("dialog", tslib_1.__assign({}, options, { buttons: buttons }));
        });
    };
    AiRoot.prototype.back = function () {
        var stopped = false;
        this.$emit("back", {
            stop: function () { stopped = true; }
        });
        if (stopped)
            return;
        if (this.$route.name == "Start")
            xamatron.exitApplication();
        else
            this.$router.back();
    };
    AiRoot = tslib_1.__decorate([
        Component({
            router: new VueRouter({
                mode: "abstract",
                linkActiveClass: "active",
                routes: routes
            }),
            i18n: new VueI18n(tslib_1.__assign({ locale: "en", fallbackLocale: "en" }, i18n))
        })
    ], AiRoot);
    return AiRoot;
}(Vue));
export default AiRoot;
function axiosParamsSerializer(params) {
    var e_1, _a;
    var parts = [];
    for (var key in params) {
        var val = params[key];
        if (val === null || val === undefined)
            continue;
        try {
            for (var _b = tslib_1.__values(Array.isArray(val) ? val : [val]), _c = _b.next(); !_c.done; _c = _b.next()) {
                var v = _c.value;
                if (v instanceof Date)
                    v = v.toISOString();
                parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(v));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return parts.join("&");
}
